import { Link } from 'react-router-dom';
import { getCategoryRoute } from '../../utils/categoryCatalog';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks: Record<string, string[]> = {
    'Информация': ['О проекте', 'Как это работает', 'Партнерам', 'Контакты'],
    'Категории': [
      'Одежда и обувь', 
      'Красота и здоровье', 
      'Образование', 
      'Электроника',
      'Дом и сад',
      'Еда и напитки'
    ],
    'Популярное': [
      'Путешествия',
      'Онлайн-сервисы',
      'Маркетплейсы',
      'Игры и развлечения'
    ],
    'Помощь': ['Политика конфиденциальности', 'Пользовательское соглашение', 'FAQ']
  };

  const linkMap: Record<string, string> = {
    'О проекте': '/about',
    'Как это работает': '/how-it-works',
    'Партнерам': '/partners',
    'Контакты': '/contacts',
    'Одежда и обувь': getCategoryRoute('Одежда и обувь'),
    'Красота и здоровье': getCategoryRoute('Красота и здоровье'),
    'Образование': getCategoryRoute('Образование'),
    'Электроника': getCategoryRoute('Электроника'),
    'Дом и сад': getCategoryRoute('Дом и сад'),
    'Еда и напитки': getCategoryRoute('Еда и напитки'),
    'Путешествия': getCategoryRoute('Путешествия'),
    'Онлайн-сервисы': getCategoryRoute('Онлайн-сервисы'),
    'Маркетплейсы': getCategoryRoute('Маркетплейсы'),
    'Игры и развлечения': getCategoryRoute('Игры и развлечения'),
    'Политика конфиденциальности': '/privacy',
    'Пользовательское соглашение': '/terms',
    'FAQ': '/faq'
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center shadow-lg mr-3">
                <i className="ri-percent-line text-white text-xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold text-gray-900 leading-tight">Promokod</span>
                <span className="text-lg font-semibold text-orange-500 leading-tight">.online</span>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Лучшие промокоды и скидки от популярных интернет-магазинов. 
              Экономьте на покупках каждый день!
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="https://t.me/promo_kod_online" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-600 hover:text-white transition-colors">
                <i className="ri-telegram-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold text-gray-900 mb-4">
                {title}
              </h4>
              <ul className="space-y-2">
                {links.map((link) => {
                  const href = linkMap[link] || '#';
                  
                  return (
                    <li key={link}>
                      <Link 
                        to={href} 
                        className="text-gray-600 hover:text-blue-600 transition-colors text-sm cursor-pointer"
                      >
                        {link}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Promokod.online. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
}
